import { Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { BillsVService, UtilityTypeEnum } from '../../services/V2/gozer';
import { withToast } from '../Shared/Toast';
import GetAppIcon from '@mui/icons-material/GetApp';
import { getUsageHistory } from '../Shared/ExportsFunctions';
import { CustomTable } from '../Shared/CustomTable';
import { IsMobile } from '../Shared/Functions';

const UsageHistory = ({ account }) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [usageConfigs, setUsageConfigs] = useState<any>(null);

    useEffect(() => {
        setUsageConfigs(account.usageInfo)
        setLoading(true)
    }, [account])// eslint-disable-line react-hooks/exhaustive-deps

    const handleDownload = async () => {
        await getUsageHistory(account.id)
    }

    return (
        <Grid container>
            <Grid xs={12} style={{ padding: "0px 25px" }}>
                <CustomTable
                    title={"USAGE HISTORY"}
                    refresh={loading}
                    setRefresh={setLoading}
                    columns={[
                        {
                            field: "meterNumber",
                            title: "Meter Number",
                            editable: 'never',
                        },
                        {
                            field: "utilityType",
                            title: "Usage Type",
                            editable: 'never',
                            render: params => `${params.utilityType} ${(params.utilityType === UtilityTypeEnum.WATER ? usageConfigs.waterDisplayUnits :
                                params.utilityType === UtilityTypeEnum.GAS ? usageConfigs.gasDisplayUnits : params.utilityType === UtilityTypeEnum.ELECTRIC ?
                                usageConfigs.electricityDisplayUnits : params.utilityType === UtilityTypeEnum.FIRE_LINE ? usageConfigs.fireLineDisplayUnits :
                                params.utilityType === UtilityTypeEnum.SPRINKLER ? usageConfigs.sprinklerDisplayUnits : "") ?? ""}`,
                            hidden: IsMobile(),
                        },
                        {
                            field: "usage",
                            title: "Usage Amount",
                            editable: 'never',
                        },
                        {
                            field: "readDate",
                            title: "Read Date",
                            editable: 'never',
                            render: params => new Date(params.readDate).toLocaleDateString()
                        }
                    ]}
                    dataEndpoint={async query => {
                        let data = await BillsVService.billsVGetAllUsages(account.id)
                        setLoading(false)
                        return {
                            data: data.sort((a,b) => a?.readDate?.localeCompare(b?.readDate ?? "") ?? 0).reverse() ?? [],
                            totalCount: data?.length ?? 0,
                            numberPerPage: 10
                        }
                    }}
                    actions={[
                        {
                            icon: () => <GetAppIcon />,
                            tooltip: "Export",
                            isFreeAction: false,
                            onClick: () => handleDownload()
                        }
                    ]}
                    pageSize={10}
                    onRowClick={null}
                />
            </Grid>
        </Grid>)
}
export default withToast(UsageHistory);